import AxiosClient from "../AxiosClient";

export const postSimpleOrderEntitySearchOrderAPI = (params) => {
  const url = "/api/simpleOrderEntry/searchOrder";
  return AxiosClient.post(url, params);
};

export const postSimpleOrderEntitySearchInitialOrderAPI = (params) => {
  const url = "/api/simpleOrderEntry/searchInitialOrder";
  return AxiosClient.post(url, params);
};

export const postSimpleOrderEntityUpdateOrderAPI = (params) => {
  const url = "/api/simpleOrderEntry/updateOrder";
  return AxiosClient.post(url, params);
};